import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  PAYER_ADDRESS_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages, { type Card, type Field, type Page } from '..';

describe('Payer Page Template', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const payerPage = pages.find(page => page.route === PAGE_ROUTES.financial) as Page;

  describe('Payer Page Structure', () => {
    it('has correct route', () => {
      expect(payerPage).toBeDefined();
      expect(payerPage.route).toBe(PAGE_ROUTES.financial);
    });

    it('contains expected cards', () => {
      expect(Array.isArray(payerPage.cards)).toBe(true);
      expect(payerPage.cards).toHaveLength(4);
    });
  });

  describe('Payer Address Card', () => {
    const payerCard = payerPage.cards!.find(
      card => card.key === CARD_CATEGORIES.payer
    ) as Card;

    it('has hideSameAs enabled', () => {
      expect(payerCard).toBeDefined();
      expect(payerCard.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(payerCard.fields?.map((f: Field) => f.key)).toEqual([
        PAYER_ADDRESS_FIELDS.address,
        PAYER_ADDRESS_FIELDS.taxNumber2,
        PAYER_ADDRESS_FIELDS.taxNumber3
      ]);
    });
  });

  describe('Attachment Cards', () => {
    it('contains financialAttachmentCard', () => {
      const financialAttachment = payerPage.cards!.find(
        card => card.key === CARD_CATEGORIES.financialAttachmentCard
      ) as Card;

      expect(financialAttachment).toBeDefined();
      expect(financialAttachment.fields?.[0].key).toBe(ATTACHMENT_FIELDS.financialCardAttachment);
    });

    it('contains additionalAttachmentCard', () => {
      const additionalAttachment = payerPage.cards!.find(
        card => card.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;

      expect(additionalAttachment).toBeDefined();
      expect(additionalAttachment.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });
  });

  describe('Privacy Policy Card', () => {
    it('exists and has no fields', () => {
      const privacyCard = payerPage.cards!.find(
        card => card.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;

      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});
